
import { useUserInfo } from 'context/user'
import localforage from 'localforage'
import { useNavigate } from 'react-router-dom'
const pathname = window.location.pathname
const email = pathname.split('/')[1]
const locationId = pathname.split('/')[2]
function useAuth() {
  const [user] = useUserInfo()
  return user?.token
}

function useLogout() {
  // const clear = useUserInfo()[2]
  const navigate = useNavigate()

  return () => {
    localforage.clear()
    // clear()
    navigate('/404')
  }
}

export { useAuth, useLogout }
